import React from 'react'
import { useState, useEffect } from 'react';
import { make_readable_date } from '../../js functions/chartCompute.js';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';

function BestSetVolume({ dateRangeStart, dateRangeEnd, ActiveExcercise }) {

    const [BestSetVolumeData, setBestSetVolumeData] = useState([]);
    const [slope, setSlope] = useState(0);
    const heading = "Best Set Volume";
    const Yaxis_name = "Weight (kg)";

    useEffect(() => {
        compute_BestSetVolume(dateRangeStart, dateRangeEnd, ActiveExcercise);
    }, [dateRangeStart, dateRangeEnd, ActiveExcercise]);






    async function compute_BestSetVolume(dateRangeStart, dateRangeEnd, ActiveExcercise) {
        try {
            const data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise); // array between from and to dates of specific exercise

            if (!data || data.length === 0) {
                console.log('No data available for the selected exercise and date range');
                setBestSetVolumeData([]);

            } else {


                const chartData = [];

                data.forEach((record) => {
                    let bestSetVolume = 0; // To store the best set volume for the workout session

                    const sets = record.sets;

                    sets.forEach((set) => {
                        // Calculate the volume for the current set
                        const setVolume = set.weight_kg * set.reps;

                        // Update the best set volume if the current set volume is greater
                        bestSetVolume = Math.max(bestSetVolume, setVolume);
                    });

                    // Push the best set volume along with the date to chartData
                    chartData.push({
                        y: bestSetVolume,
                        x: make_readable_date(record.start_time),
                    });
                });
                setBestSetVolumeData(chartData);
            }






        }
        catch (error) {
            console.log(error);
        }
    }


    return (
        <div className='chart-card-container'>
            <h4>{heading}</h4>

            <div className="chart-card">


                <div className='summary-box' >



                    <div className='counter-box' >

                        <Counter counterData={slope} heading={"Slope"} />

                        <Counter />

                    </div>


                    <p> Great job! Your total volume for incline dumbbell press has increased by 15% over the last month. This shows your chest and upper body strength are improving steadily. Keep it up!  </p>
                </div>



                <Line_chart data={BestSetVolumeData} Yaxis_name={Yaxis_name} />



            </div>


        </div>
    )
}

export default BestSetVolume


